import { toLocationGroupAddressInput } from './address-form-rules.js';
export function toUpdateLocationGroupInput(values) {
    return {
        name: values.name.trim(),
        // Carried on the same input so the server writes both in one transaction; undefined when every
        // address field is blank, which leaves an existing address untouched rather than clearing it.
        address: toLocationGroupAddressInput(values),
    };
}
//# sourceMappingURL=update-mapper.js.map